/*import React from 'react';
import './CheckoutProduct.css';
import { useStateValue } from './StateProvider';
import { db, auth } from './firebase';
import { doc, deleteDoc, updateDoc, getDoc } from "firebase/firestore";

function CheckoutProduct({id, image, title, price, size, quantity, alter, originalID, hideButton}) {

  const [{basket}, dispatch] = useStateValue();

  const removeFromBasket = async () => {
    const user = auth.currentUser;
    const finalID = originalID ?? id;
    const itemKey = `${finalID}_${size || null}`;

    
    dispatch({
        type: 'REMOVE_FROM_BASKET',
        id: finalID,
        size: size ?? null
    });

    
    if (user) {
        const cartRef = doc(db, "users", user.uid, "carrello", itemKey);
        const docSnap = await getDoc(cartRef);

        if (docSnap.exists()) {
            const currentQty = docSnap.data().quantity;
            if (currentQty > 1) {
                await updateDoc(cartRef, { quantity: currentQty - 1 });
            } else {
                await deleteDoc(cartRef);
            }
        }
    }
  }


  return (
    <div className='checkoutProduct'>
        <img className='checkoutProduct_image' src={image} alt={alter}/>

        <div className='checkoutProduct_info'>
            <p className='checkoutProduct_title'>{title}</p>
            <p className='checkoutProduct_size'>{size}</p>
            <p className='checkoutProduct_price'>
                <small>€</small>
                <strong>{price}</strong>
            </p>

            <p className='checkoutProduct_quantity'>Quantità: {quantity}</p>
            <p className='checkoutProduct_subtotal'>
            Subtotale: €{(price * quantity).toFixed(2)}
            </p>

            {!hideButton && (<button onClick={removeFromBasket}>Rimuovi dal carrello</button>)}
            
        </div>
    </div>
  )
}

export default CheckoutProduct*/

import React from 'react';
import './CheckoutProduct.css';
import { useStateValue } from './StateProvider';
import { db, auth } from './firebase';
import { doc, deleteDoc, updateDoc, getDoc } from "firebase/firestore";

function CheckoutProduct({ id, image, title, price, size, quantity, alter, originalID, hideButton }) {
  const [{ basket }, dispatch] = useStateValue();

  const removeFromBasket = async () => {
    const user = auth.currentUser;
    const finalID = originalID ?? id;
    const itemKey = `${finalID}_${size || null}`;

    // Svuota/Decrementa nello stato globale React
    dispatch({
      type: 'REMOVE_FROM_BASKET',
      id: finalID,
      size: size ?? null
    });

    // Svuota/Decrementa nel database Firestore (se loggato)
    if (user) {
      const cartRef = doc(db, "users", user.uid, "carrello", itemKey);
      const docSnap = await getDoc(cartRef);

      if (docSnap.exists()) {
        const currentQty = docSnap.data().quantity;
        if (currentQty > 1) {
          await updateDoc(cartRef, { quantity: currentQty - 1 });
        } else {
          await deleteDoc(cartRef);
        }
      }
    }
  };

  // Calcola la quantità sicura (default 1) per evitare valori nuli
  const safeQuantity = quantity || 1;

  return (
    <div className='checkoutProduct'>
      <img className='checkoutProduct_image' src={image} alt={alter || title} />

      <div className='checkoutProduct_info'>
        <p className='checkoutProduct_title'>{title}</p>
        
        {size && <p className='checkoutProduct_size'>{size}</p>}

        <p className='checkoutProduct_price'>
          <small>€</small>
          <strong>{price}</strong>
        </p>

        {/* Quantità mostrata sia nel carrello che nella pagina ordini */}
        <p className='checkoutProduct_quantity'>Quantità: {safeQuantity}</p>

        {/* Il Subtotale e il pulsante Rimuovi vengono mostrati SOLO se non siamo nella pagina Ordini (!hideButton) */}
        {!hideButton && (
          <>
            <p className='checkoutProduct_subtotal'>
              Subtotale: €{(price * safeQuantity).toFixed(2)}
            </p>
            <button onClick={removeFromBasket}>Rimuovi dal carrello</button>
          </>
        )}
      </div>
    </div>
  );
}

export default CheckoutProduct;